import { Link } from "react-router-dom";
import { useTranslations } from "use-intl";
import { useAuth } from "../auth";

export const AuthUserMenu = () => {
  const t = useTranslations("auth");
  const { signOut, user } = useAuth();
  return (
    <div className="auth-user-menu">
      <span data-flowtrace-block title={user?.email}>{user?.email}</span>
      <Link data-flowtrace-id="nav.mcp-access" to="/mcp-access">{t("mcpAccess")}</Link>
      <button data-flowtrace-id="auth.sign-out" onClick={() => void signOut()} type="button">{t("signOut")}</button>
    </div>
  );
};
